module.exports = __webpack_public_path__ + "static/media/191CS218.7688299e.jpg";